import React, { Component } from "react";
import {
  Spin,
  Form,
  Row,
  Col,
  Switch,
  message,
  Divider,
  Button,
  Alert,
  Tooltip,
  Radio,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
import {
  FormItem,
  ButtonItem,
  SelectItem,
} from "../../../../Components/Items";
import RichTextEditor from "../../../../Components/RichTextEditor";
import DynamicCardForm from "../../../../Components/DynamicCardForm";

import axios from "axios";

// Variantes disponibles para la tarjeta de producto en el catálogo
const VARIANTES_CARD_PRODUCTO = [
  {
    value: "ProductCardBase",
    label: "Tarjeta Base",
    descripcion:
      "Diseño clásico con imagen arriba, nombre, precio y botón de agregar al carrito. Ideal para la mayoría de catálogos.",
  },
  {
    value: "ProductCardAlt",
    label: "Tarjeta Alternativa",
    descripcion:
      "Diseño más compacto con botón de agregar al carrito al lado del precio. Perfecta para catálogos con muchas opciones o para mostrar más productos en pantalla . ",
  },
  {
    value: "ProductCardRounded",
    label: "Tarjeta Redondeada",
    descripcion:
      "Diseño con bordes redondeados y sombra suave. Da un aspecto moderno y amigable, ideal para tiendas con enfoque en diseño.",
  },
  {
    value: "ProductCardOverlay",
    label: "Tarjeta con Overlay",
    descripcion:
      "Diseño con la tarjeta mostrando imagen, texto y precio. El boton de agregar al carrito aparece al pasar el mouse sobre la imagen. Perfecta para un look más dinámico y moderno.",
  },
];

const getVarianteCardDescripcion = (value) =>
  VARIANTES_CARD_PRODUCTO.find((v) => v.value === value)?.descripcion || "";

class InsumosConfiguracion extends Component {
  formRef = React.createRef();
  state = { loading: false, formConCambios: false };

  componentDidMount() {
    this.consultarConfiguracion();
  }

  consultarConfiguracion = () => {
    this.setState({ loading: true });
    axios
      .post(
        "configuracionTiendaOnline/obtenerConfiguracionInsumos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2 && res.data.data) {
          this.formRef.current.setFieldsValue(res.data.data);
        }
      })
      .finally(() => this.setState({ loading: false }));
  };

  onFinish = async (values) => {
    this.setState({ loading: true });
    const payload = { empresaId: this.props.empresaId, ...values };
    try {
      const res = await axios.post(
        "configuracionTiendaOnline/actualizarConfiguracionInsumos",
        payload,
        { headers: this.props.headersToken },
      );
      if (res.data.success === 2) {
        message.success("Configuración guardada correctamente");
        this.setState({ formConCambios: false });
        return true;
      }
    } catch (error) {
      message.error("Error al guardar");
      return false;
    } finally {
      this.setState({ loading: false });
    }
  };

  tieneCambios = () => this.state.formConCambios;
  descartarCambios = () => {
    this.setState({ formConCambios: false });
    this.consultarConfiguracion();
  };
  guardarDesdePadre = () =>
    this.formRef.current
      .validateFields()
      .then(this.onFinish)
      .catch(() => false);

  render() {
    return (
      <Spin spinning={this.state.loading}>
        <Form
          ref={this.formRef}
          layout="vertical"
          onFinish={this.onFinish}
          onValuesChange={() =>
            !this.state.formConCambios &&
            this.setState({ formConCambios: true })
          }
        >
          <Row gutter={24}>
            <Col span={10}>
              <DynamicCardForm
                title={"Opciones de Visualización"}
                style={{
                  margin: "0 auto 12px auto",
                  maxWidth: "98%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 15,
                  }}
                >
                  <span>Mostrar Clave</span>
                  <FormItem name="mostrarClave" valuePropName="checked" noStyle>
                    <Switch />
                  </FormItem>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 15,
                  }}
                >
                  <span>
                    Código Proveedor{" "}
                    <Tooltip title="Reemplaza la clave interna del insumo por el código del proveedor. Solo aplica cuando 'Mostrar Clave' está activo.">
                      <InfoCircleOutlined style={{ color: "#bfbfbf" }} />
                    </Tooltip>
                  </span>
                  <Form.Item
                    noStyle
                    shouldUpdate={(p, c) => p?.mostrarClave !== c?.mostrarClave}
                  >
                    {({ getFieldValue }) => {
                      const claveActiva = getFieldValue("mostrarClave");
                      return (
                        <FormItem
                          name="mostrarClaveProveedor"
                          valuePropName="checked"
                          noStyle
                        >
                          <Switch disabled={!claveActiva} />
                        </FormItem>
                      );
                    }}
                  </Form.Item>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 15,
                  }}
                >
                  <span>Mostrar Código de Barras</span>
                  <FormItem
                    name="mostrarCodigoBarras"
                    valuePropName="checked"
                    noStyle
                  >
                    <Switch />
                  </FormItem>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 15,
                  }}
                >
                  <span>Mostrar Leyenda de Inventario</span>
                  <FormItem name="mostrarStock" valuePropName="checked" noStyle>
                    <Switch />
                  </FormItem>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>Mostrar Leyenda Dropshipping</span>
                  <FormItem
                    name="mostrarDropshipping"
                    valuePropName="checked"
                    tooltip="Mostrar la leyenda 'Bajo pedido' para los productos de dropshipping cuando no tengan stock"
                    noStyle
                  >
                    <Switch />
                  </FormItem>
                </div>
              </DynamicCardForm>

              <DynamicCardForm
                title={"Variante de Tarjeta de Producto"}
                style={{
                  margin: "0 auto 12px auto",
                  maxWidth: "98%",
                }}
              >
                <FormItem
                  label="Selecciona el estilo de tarjeta"
                  name="varianteCardProducto"
                  tooltip="Define el diseño visual de las tarjetas de producto en el catálogo del sitio."
                >
                  <SelectItem
                    placeholder="Selecciona una variante"
                    options={VARIANTES_CARD_PRODUCTO.map((v) => ({
                      value: v.value,
                      label: v.label,
                    }))}
                  />
                </FormItem>

                <Form.Item
                  noStyle
                  shouldUpdate={(p, c) =>
                    p?.varianteCardProducto !== c?.varianteCardProducto
                  }
                >
                  {({ getFieldValue }) => {
                    const v = getFieldValue("varianteCardProducto");
                    const descripcion = getVarianteCardDescripcion(v);
                    if (!descripcion) return null;
                    return (
                      <div
                        style={{
                          background: "#f5fbfd",
                          borderLeft: "3px solid #00BFD6",
                          padding: "8px 12px",
                          borderRadius: 4,
                          fontSize: 12,
                          color: "#555",
                          lineHeight: 1.5,
                        }}
                      >
                        {descripcion}
                      </div>
                    );
                  }}
                </Form.Item>
              </DynamicCardForm>

              <DynamicCardForm
                title={"Textos de Compra"}
                style={{
                  margin: "0 auto 12px auto",
                  maxWidth: "98%",
                }}
              >
                <p
                  style={{ fontSize: "12px", color: "#888", marginBottom: 15 }}
                >
                  <InfoCircleOutlined /> Estos bloques aparecerán debajo del
                  botón de comprar.
                </p>

                <Form.List name="textosAdicionales">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map((field) => (
                        <div
                          key={field.key}
                          style={{
                            border: "1px solid #f0f0f0",
                            padding: "15px",
                            borderRadius: "8px",
                            marginBottom: "20px",
                            background: "#fafafa",
                            position: "relative",
                          }}
                        >
                          <Button
                            type="text"
                            danger
                            icon={<DeleteOutlined />}
                            onClick={() => remove(field.name)}
                          />
                          <FormItem {...field} style={{ marginBottom: 0 }}>
                            <RichTextEditor
                              placeholder="Escribe un mensaje llamativo..."
                              height={50}
                            />
                          </FormItem>
                        </div>
                      ))}
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                        style={{ height: "45px" }}
                      >
                        Agregar Nuevo Bloque de Texto
                      </Button>
                    </>
                  )}
                </Form.List>
              </DynamicCardForm>

              {this.props.escuela && (
                <DynamicCardForm
                  title={"Libro Virtual"}
                  style={{
                    margin: "0 auto 12px auto",
                    maxWidth: "98%",
                  }}
                >
                  <FormItem
                    name="momentoAsignacionLibroVirtual"
                    label="¿Cuándo asignar el código de Libro Virtual?"
                    initialValue="pago"
                    tooltip="Define si el código único se asigna en cuanto se confirma el pago (requiere que ya haya códigos disponibles en ese momento) o hasta que se entregue toda la venta."
                  >
                    <Radio.Group>
                      <Radio value="pago">Al confirmar el pago</Radio>
                      <Radio value="entrega">Al completar la entrega de la venta</Radio>
                    </Radio.Group>
                  </FormItem>
                </DynamicCardForm>
              )}
            </Col>

            <Col span={14}>
              <DynamicCardForm
                title={"Condiciones de Envío del Insumo"}
                style={{
                  margin: "0 auto 12px auto",
                  maxWidth: "98%",
                }}
              >
                <FormItem name="textoEnvio">
                  <RichTextEditor placeholder="Describe los tiempos de entrega, costos, etc. Ej: Entrega en 3 a 5 días. Envío a todo a México." />
                </FormItem>
              </DynamicCardForm>

              <DynamicCardForm
                title={"Restricciones para el envio de insumos"}
                style={{
                  margin: "0 auto 12px auto",
                  maxWidth: "98%",
                }}
              >
                <Alert
                  message={
                    "Antes de publicar cualquier producto te invitamos a visitar la página de Envia.com respecto a varios productos que no pueden ser enviados por las paqueterias. Esto con el fin de ayudarte a evitar cualquier tipo de multa o suspensión de tu cuenta. "
                  }
                  type={"error"}
                  showIcon
                  style={{ marginTop: 10, marginBottom: 15, width: "100%" }}
                />
                <ButtonItem
                  type="primary"
                  href={
                    "https://help.envia.com/articulos-prohibidos-y-restringidos/"
                  }
                  target="_blank"
                >
                  Ir a ver las restricciones
                </ButtonItem>

                <iframe
                  src={"https://help.envia.com/articulos-prohibidos-y-restringidos/"}
                  title="Vista Previa Demo"
                  style={{
                    marginTop : "10px",
                    width: "100%",
                    height: "100%",
                    border: "none",
                  }}
                />
              </DynamicCardForm>
            </Col>
          </Row>

          <Divider />
          <ButtonItem
            type="primary"
            htmlType="submit"
            style={{ display: "block", margin: "0 0 0 auto" }}
          >
            Guardar Cambios en Insumos
          </ButtonItem>
        </Form>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  escuela: state.empresa.escuela,
});
export default connect(mapStateToProps, null, null, { forwardRef: true })(
  InsumosConfiguracion,
);
